import type { Column } from "@/types/array.types";

export function validateForm<T>(
    values: Partial<T>,
    columns: Column<T>[]
  ): Partial<Record<keyof T, string>> {
    const errors: Partial<Record<keyof T, string>> = {};
  
    columns.forEach((column) => {
      const value = values[column.key];
  
      if (
        column.required &&
        (value === "" || value === undefined || value === null)
      ) {
        errors[column.key] = `${column.label} est obligatoire.`;
        return;
      }
  
      if (column.validate) {
        const error = column.validate(value as T[keyof T]);
  
        if (error) {
          errors[column.key] = error;
        }
      }
    });
  
    return errors;
  }

  export const validateCreateUserForm = (values: {
    email?: string;
    password?: string;
    full_name?: string;
    role_id?: string;
  }) => {
    const errors: Record<string, string> = {};
  
    if (!values.email) {
      errors.email = "L'email est obligatoire";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
      if (!emailRegex.test(values.email)) {
        errors.email = "Format d'email invalide";
      }
    }
  
    if (!values.password) {
      errors.password = "Le mot de passe est obligatoire";
    } else {
      if (values.password.length < 12) {
        errors.password = "12 caractères minimum";
      } else if (!/[A-Z]/.test(values.password)) {
        errors.password = "Une majuscule est obligatoire";
      } else if (!/[0-9]/.test(values.password)) {
        errors.password = "Un chiffre est obligatoire";
      } else if (!/[^A-Za-z0-9]/.test(values.password)) {
        errors.password = "Un symbole est obligatoire";
      }
    }
  
    if (!values.full_name || values.full_name.trim() === "") {
      errors.full_name = "Le nom est obligatoire";
    }
  
    if (!values.role_id) {
      errors.role_id = "Le rôle est obligatoire";
    }
  
    return errors;
  };

  export const validateInviteUserForm = (values: {
    email?: string;
    full_name?: string;
    role_id?: string;
  }) => {
    const errors: Record<string, string> = {};
  
    if (!values.email) {
      errors.email = "L'email est obligatoire";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
      if (!emailRegex.test(values.email)) {
        errors.email = "Format d'email invalide";
      }
    }
  
    if (!values.full_name || values.full_name.trim() === "") {
      errors.full_name = "Le nom est obligatoire";
    }
  
    if (!values.role_id) {
      errors.role_id = "Le rôle est obligatoire";
    }
  
    return errors;
  };